import { Button } from '@/components';
import { MasterTranslation } from '@/constants';
import { useGlobalState } from '@/hooks';
import { ButtonSize, ButtonVariant } from '@/interfaces';
import styled from 'styled-components';

const CustomButton = styled(Button).attrs({
  size: ButtonSize.Large,
  isPMTButton: true,
  truncate: true,
})`
  width: 100%;
  text-transform: uppercase;

  &:focus {
    outline: revert;
  }
`;

export const LoadMore = ({ onClick }: { onClick: () => void }) => {
  const { t } = useGlobalState();

  return (
    <CustomButton onClick={onClick} variant={ButtonVariant.Secondary}>
      {t(MasterTranslation.LoadMore)}
    </CustomButton>
  );
};
